import { ApiError } from '@/lib/api'

/**
 * A `404` from this route means one thing only: the `advertising_meta` flag is
 * off (docs/architecture/integrations-meta.md §12.1). The page reads it as the
 * "not entitled" empty state, never as a generic failure.
 */
export function isFlagOff(error: unknown): boolean {
  return error instanceof ApiError && error.status === 404
}

export function isForbidden(error: unknown): boolean {
  return error instanceof ApiError && error.status === 403
}

const UNAVAILABLE = 'The campaign report is temporarily unavailable. Try again in a moment.'

export function advertisingErrorMessage(error: unknown, fallback: string = UNAVAILABLE): string {
  if (isForbidden(error)) return 'Your role cannot see advertising data. Ask an Owner or Administrator for access.'
  if (error instanceof ApiError && error.status === 429) return 'Too many requests just now. Wait a minute and try again.'
  if (error instanceof ApiError && error.status === 502) return 'Meta did not answer just now. Wait a few minutes and try again.'
  return fallback
}
